import { Outlet } from "react-router";
import AppBottom from "./app-bottom";
import AppTop from "./app-top";
import {
  AdinplayBottom,
  AdinplaySquare,
  AdinplayTall,
} from "./components/common/ad/adinplay";
import useStyle from "./components/common/styled/styled";
import Streamer from "./components/common/twitch/twitch";
import { useAppSelector } from "./redux/store";
import { selectAudienceCount, selectRoomCode, selectConnectionStatus } from "./redux/selectors";
import { ConnectionStatus } from "./redux/slices/meta";

const GameLayout = () => {
  const numAudience = useAppSelector(selectAudienceCount);
  const roomCode = useAppSelector(selectRoomCode);
  const connectionStatus = useAppSelector(selectConnectionStatus);
  const style = useStyle();
  const theme = style.theme;

  function extraLabel() {
    return numAudience > 0 ? numAudience.toString() : undefined;
  }

  // Show connection status if we have a room code OR if we're actively connecting/reconnecting
  function shouldHideConnectionStatus() {
    // If we have a room code, always show the status
    if (roomCode) return false;
    
    // If no room code but we're connecting or reconnecting, show the status
    // This handles the reconnection scenario where room code isn't available yet
    return connectionStatus === ConnectionStatus.DISCONNECTED;
  }

  return (
    <div
      className={`min-h-full flex flex-col relative franticfanficbg ${theme}`}
    >
      <div className="relative flex-grow items-stretch flex flex-row">
        <aside className={"basis-0 flex-grow flex flex-col-reverse"}>
          <Streamer />
        </aside>
        <main className="flex flex-col  max-w-[640px] w-full ">
          <AppTop roomCode={roomCode} extraLabel={extraLabel()} />
          <Outlet />
          <AppBottom hideConnected={shouldHideConnectionStatus()} />
        </main>
        <aside className={"basis-0 flex-grow flex flex-col-reverse"}>
          <AdinplayTall />
          <AdinplaySquare />
        </aside>
      </div>

      <div className={"hidden relative mt-2 self-start md:block"}>
        © Frantic Fanfic 2025
      </div>
      <AdinplayBottom />
    </div>
  );
};

export default GameLayout;
